var DeviceType;
(function (DeviceType) {
    DeviceType["WEB"] = "Web";
    DeviceType["TABLET"] = "Tablet";
    DeviceType["MOBILE_WEB"] = "Mobile Web";
    DeviceType["MOBILE_IOS"] = "Mobile iOS";
    DeviceType["MOBILE_ANDROID"] = "Mobile Android";
})(DeviceType || (DeviceType = {}));
export { DeviceType };
